// Set of functions that mimic the Excel financial functions

export function pmt (rate, nper, pv, fv, type) {
    if (arguments.length < 5) var type = 0;
    if (arguments.length < 4) var fv = 0;
    if (arguments.length < 3) throw "Missing required arguments";
    if (typeof rate != 'number') throw "Rate must be a number";
    if (typeof nper != 'number') throw "Periods must be a number";
    if (typeof pv != 'number') throw "Present value must be a number";
    if (type !== 0 && type !== 1) throw "Type must be either 0 or 1";

    if (rate == 0) {
        return -(pv + fv) / nper;
    } else {
        var pow = Math.pow(1 + rate, nper);
        var pmt = rate / (pow - 1) * -(pv * pow + fv);
        if (type == 1) pmt /= (1 + rate);
        return pmt;
    }
}

export function fv (rate, nper, pmt, pv, type) {
    if (arguments.length < 5) var type = 0;
    if (arguments.length < 4) var pv = 0;
    if (arguments.length < 3) throw "Missing required arguments";
    if (typeof rate != 'number') throw "Rate must be a number";
    if (typeof nper != 'number' || nper < 0) throw "Number of periods must be a positive number";
    if (typeof pmt != 'number') throw "Payment must be a number";
    if (type !== 0 && type !== 1) throw "Type must be either 0 or 1";

    if (rate == 0) {
        return -(pv + pmt * nper);
    } else {
        var pow = Math.pow(1 + rate, nper);
        return pmt * (1 + rate * type) * (1 - pow) / rate - pv * pow;
    }
}
export function nper (rate, pmt, pv, fv, type) {
    if (arguments.length < 5) var type = 0;
    if (arguments.length < 4) var fv = 0;
    if (arguments.length < 3) throw "Missing required arguments";
    if (typeof rate != 'number') throw "Rate must be a number";
    if (typeof pmt != 'number') throw "Payment must be a number";
    if (typeof pv != 'number') throw "Present value must be a number";
    if (type !== 0 && type !== 1) throw "Type must be either 0 or 1";

    if (rate == 0) {
        return -(pv + 0) / pmt;
    } else {
        return Math.log10((pmt * (1 + rate * type) - fv * rate) / (pmt * (1 + rate * type) + pv * rate)) / Math.log10(1 + rate);
    }
}
export function pv (rate, periods, payment, future, type) {
    if (arguments.length < 5) var type = 0;
    if (arguments.length < 4) var future = 0;
    if (arguments.length < 3) throw "Missing required arguments";
    // Initialize type
    var type = (typeof type === 'undefined') ? 0 : type;

    // Evaluate rate and periods (TODO: replace with secure expression evaluator)
    rate = eval(rate);
    periods = eval(periods);

    // Return present value
    if (rate === 0) {
        return - payment * periods - future;
    } else {
        return (((1 - Math.pow(1 + rate, periods)) / rate) * payment * (1 + rate * type) - future) / Math.pow(1 + rate, periods);
    }
}